import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { denyAlert } from "../../pages/alerts/alertsNeedingApproval/denyAlertSlice";
import { listApprovalAlert } from "../../pages/alerts/alertsNeedingApproval/listApprovalSlice";
import useNotification from "../notification/useNotification";
import { isSuccessResponse } from "../../common/utils";

const Modal4DenyAllAlert = ({ data }: { data?: any }) => {
  const dispatch: any = useDispatch();
  const denyId: string[] = data?.map((item) => item._id);
  const [show, setShow] = useState<boolean>(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { showSuccessNotification, showWarningNotification } = useNotification();
  const handleDenyAllClose = async () => {
    handleClose();
    if (denyId.length > 0) {
      const subscriptionIds: string[] = denyId;
      try {
        await dispatch(denyAlert(subscriptionIds)).then((response) => {
          if (isSuccessResponse(response.payload)) {
            dispatch(listApprovalAlert());
            showSuccessNotification(response.payload.message);
          }
          else {
            showWarningNotification(response.payload.response.data.message);
          }
        });
      } catch (error) {
        console.error("Error:", error);
      }
    }
    setShow(false);
  };

  return (
    <>
      <Button onClick={handleShow} className="buttonbase">
        Deny All
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container modalDenyalerts"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <h1>Deny All Alert</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to deny all alerts?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleDenyAllClose}>
            Deny All
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Modal4DenyAllAlert;
